<template>
  <div id="app" style="padding:20px;">
    <!-- 登录 -->
    <el-card>
      <h3>登录</h3>
      <el-button type="primary" @click="login">登录</el-button>
      <div v-if="satoken">
        <el-alert title="登录成功" type="success" :closable="false" />
        <p>satoken={{ satoken }}</p>
      </div>
    </el-card>

    <!-- Excel 模板 + 导入 + 一键执行 -->
    <el-card style="margin-top:20px;">
      <h3>Excel 模板</h3>
      <el-button type="success" @click="downloadTemplate">下载模板</el-button>
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="importExcel"
        accept=".xlsx,.xls"
        style="margin-left:20px;display:inline-block;"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">拖拽或<em>点击上传</em></div>
      </el-upload>
      <el-button
        type="danger"
        style="margin-left:20px;"
        :disabled="!tableData.length || !satoken"
        @click="executeAll"
      >
        一键执行
      </el-button>
    </el-card>

    <!-- 表格 -->
    <el-card style="margin-top:20px;">
      <h3>数据表格</h3>
      <el-table :data="tableData" border>
        <el-table-column prop="产品名" label="产品名"></el-table-column>
        <el-table-column prop="版位" label="版位"></el-table-column>
        <el-table-column prop="推广目标" label="推广目标"></el-table-column>
        <el-table-column prop="素材类型" label="素材类型"></el-table-column>
        <el-table-column prop="广告主id" label="广告主id"></el-table-column>
        <el-table-column prop="预设归因" label="预设归因"></el-table-column>
        <el-table-column prop="转化事件类型" label="转化事件类型"></el-table-column>
        <el-table-column prop="数据源ID" label="数据源ID"></el-table-column>
        <el-table-column label="日志">
          <template slot-scope="scope">
            <el-button size="mini" @click="showLogs(scope.row)">查看日志</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 日志弹窗 -->
    <el-dialog title="执行日志" :visible.sync="logDialogVisible" width="60%">
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in currentLogs"
          :key="index"
          :timestamp="item.step"
        >
          {{ item.result }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
  name: "App",
  data: function () {
    return {
      satoken: "",
      tableData: [],
      logsMap: {},
      logDialogVisible: false,
      currentLogs: [],
      appList: [
        { appId: 100056, appName: "知隙答" },
        { appId: 100055, appName: "皛色坊" },
        { appId: 100054, appName: "壁叙集" },
        { appId: 100048, appName: "懒人记账" },
        { appId: 100040, appName: "躞蹀步云" },
        { appId: 100003, appName: "白鲸免费小说" },
        { appId: 100001, appName: "仓鼠免费小说" },
        { appId: 100007, appName: "猎豹免费小说" },
        { appId: 100009, appName: "猫头鹰免费小说" },
        { appId: 100010, appName: "深夜翻书免费小说" },
        { appId: 100011, appName: "异能天启小说大全" },
        { appId: 100018, appName: "呱呱阅读" },
        { appId: 100023, appName: "先见天气" },
        { appId: 100028, appName: "测试魔方" },
        { appId: 100029, appName: "测试智库" },
        { appId: 100033, appName: "诗意起名" },
        { appId: 100039, appName: "巉惠仓" },

      ],
      attributionList: [


           {
            id: 37,
            proxyId: 17,
            activationReturnPercent: {
              source: "100.0",
              parsedValue: 100
            },
            attributionBehavior: 6,
            attributionBehaviorParams: [
              {
                name: "ACCU_ARPU_NEW",
                value: 4.2,
                required: false,
                expression: "$gte"
              },
              {
                name: "ARPU",
                value: 0.1,
                required: true,
                expression: "$gte"
              }
            ],
            title: "联盟字体h5",
            description: "出价6"
          },
       {
            id: 98,
            proxyId: 17,
            activationReturnPercent: {
              source: "100.0",
              parsedValue: 100
            },
            attributionBehavior: 6,
            attributionBehaviorParams: [
              {
                name: "ACCU_ARPU_NEW",
                value: 4.2,
                required: true,
                expression: "$gte"
              }
            ],
            title: "联盟清理",
            description: "出价4"
          },

        {
            id: 103,
            proxyId: 17,
            activationReturnPercent: {
              source: "100.0",
              parsedValue: 100
            },
            attributionBehavior: 6,
            attributionBehaviorParams: [
              {
                name: "ARPU",
                value: 0.2,
                required: true,
                expression: "$gte"
              },
              {
                name: "ACCU_ARPU_ROI",
                value: 8,
                required: true,
                expression: "$gte"
              }
            ],
            title: "联盟h5清理2",
            description: "出价7"
          },

        {
            id: 104,
            proxyId: 17,
            activationReturnPercent: {
              source: "100.0",
              parsedValue: 100
            },
            attributionBehavior: 6,
            attributionBehaviorParams: [
              {
                name: "ACCU_ARPU_ROI",
                value: 6.5,
                required: true,
                expression: "$gte"
              }
            ],
            title: "联盟清理2",
            description: "出价6"
          }
        ,
        {
          id: 37,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_NEW",
              value: 4.2,
              required: false,
              expression: "$gte"
            },
            {
              name: "ARPU",
              value: 0.1,
              required: true,
              expression: "$gte"
            }
          ],
          title: "联盟h5",
          description: "出价6"
        },
        {
          id: 38,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_NEW",
              value: 35,
              required: false,
              expression: "$gte"
            }
          ],
          title: "站内H5短剧2",
          description: "出价30"
        },
        {
          id: 39,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_NEW",
              value: 5.5,
              required: true,
              expression: "$gte"
            }
          ],
          title: "常规站内h5-巉惠仓1",
          description: "可跑正出价在4-5"
        },
        {
          id: 55,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "OCPX_PRICE_THREE_MIN",
              value: 1.2,
              required: false,
              expression: "$mult"
            },
            {
              name: "ARPU",
              value: 0.3,
              required: true,
              expression: "$gte"
            }
          ],
          title: "站内清理1",
          description: "出价12-15 测高出价"
        },
        {
          id: 56,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU",
              value: 3.2,
              required: true,
              expression: "$gte"
            }
          ],
          title: "站内字体1",
          description: "出价5 调整需同步"
        },
        {
          id: 66,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_ROI",
              value: 6.5,
              required: true,
              expression: "$gte"
            }
          ],
          title: "站内清理2",
          description: "建议出价6"
        },
        {
          id: 70,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_ROI",
              value: 6.5,
              required: false,
              expression: "$gte"
            },
            {
              name: "ARPU",
              value: 0.1,
              required: true,
              expression: "$gte"
            }
          ],
          title: "联盟激活",
          description: "建议出价6"
        },
        {
          id: 71,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_NEW",
              value: 5.5,
              required: true,
              expression: "$gte"
            }
          ],
          title: "站内h5清理2",
          description: "建议初始出价6"
        },
        {
          id: 98,
          proxyId: 17,
          activationReturnPercent: {
            source: 100.0,
            parsedValue: 100
          },
          attributionBehavior: 6,
          attributionBehaviorParams: [
            {
              name: "ACCU_ARPU_NEW",
              value: 4,
              required: true,
              expression: "$gte"
            }
          ],
          title: "天气联盟激活",
          description: "出价4"
        },



        //
        //    {
        //     id: 37,
        //     proxyId: 17,
        //     activationReturnPercent: {
        //       source: "100.0",
        //       parsedValue: 100
        //     },
        //     attributionBehavior: 6,
        //     attributionBehaviorParams: [
        //       {
        //         name: "ACCU_ARPU_NEW",
        //         value: 8,
        //         required: false,
        //         expression: "$gte"
        //       }
        //     ],
        //     title: "站内加桌短剧1",
        //     description: "出价8"
        //   },
        //
        //
        //
        //
        //   {
        //     id: 38,
        //     proxyId: 17,
        //     activationReturnPercent: {
        //       source: "100.0",
        //       parsedValue: 100
        //     },
        //     attributionBehavior: 6,
        //     attributionBehaviorParams: [
        //       {
        //         name: "ACCU_ARPU_NEW",
        //         value: 35,
        //         required: false,
        //         expression: "$gte"
        //       }
        //     ],
        //     title: "站内加桌短剧2",
        //     description: "出价30"
        //   },
        //
        //
        //
        //
        // {
        //   id: 37, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ARPU", value: 0.1, required: true, expression: "$gte" },
        //     { name: "ACCU_ARPU", value: 4.2, required: false, expression: "$gte" }
        //   ],
        //   title: "站内h5短剧1"
        // },
        // {
        //   id: 38, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU_ROI", value: 6.5, required: false, expression: "$gte" }
        //   ],
        //   title: "站内h5清理1"
        // },
        // {
        //   id: 39, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ARPU", value: 0.1, required: true, expression: "$gte" },
        //     { name: "ACCU_ARPU", value: 4.2, required: false, expression: "$gte" }
        //   ],
        //   title: "常规站内h5-巉惠仓1"
        // },
        // {
        //   id: 55, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ARPU", value: 0.12, required: true, expression: "$gte" },
        //     { name: "ACCU_ARPU", value: 3.2, required: false, expression: "$gte" }
        //   ],
        //   title: "站内清理1"
        // },
        // {
        //   id: 56, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU_ROI", value: 6.5, required: true, expression: "$gte" }
        //   ],
        //   title: "站内字体1"
        // },
        // {
        //   id: 65, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU_NEW", value: 4, required: true, expression: "$gte" }
        //   ],
        //   title: "联盟清理1"
        // },
        // {
        //   id: 66, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU_ROI", value: 6.5, required: true, expression: "$gte" }
        //   ],
        //   title: "站内清理2"
        // },
        // {
        //   id: 70, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU", value: 3.5, required: true, expression: "$gte" }
        //   ],
        //   title: "联盟清理2"
        // },
        // {
        //   id: 71, proxyId: 17, attributionBehavior: 6,
        //   attributionBehaviorParams: [
        //     { name: "ACCU_ARPU", value: 4.2, required: true, expression: "$gte" }
        //   ],
        //   title: "站内h5清理2"
        // }
      ]
    };
  },
  methods: {
    login: function () {
      var self = this;
      axios
        .post("https://control.zjwec.cn/csmf/login", {
          username: "zhiwei",
          password: "zhiweiFJ#0903",
          autoLogin: false,
          type: "account"
        })
        .then(function (res) {
          if (res.data && res.data.satoken) {
            self.satoken = res.data.satoken;
            self.$message.success("登录成功");
          } else {
            self.$message.error("登录失败");
          }
        })
        .catch(function (err) {
          self.$message.error("登录出错: " + err);
        });
    },
    downloadTemplate: function () {
      var ws = XLSX.utils.json_to_sheet([
        {
          产品名: "",
          版位: "",
          推广目标: "",
          素材类型: "",
          广告主id: "",
          预设归因: "",
          转化事件类型: "",
          数据源ID: ""
        }
      ]);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "模板");
      XLSX.writeFile(wb, "模板.xlsx");
    },
    importExcel: function (param) {
      var self = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });
        var sheetName = workbook.SheetNames[0];
        var sheet = workbook.Sheets[sheetName];
        self.tableData = XLSX.utils.sheet_to_json(sheet);
      };
      reader.readAsArrayBuffer(param.file);
    },
    showLogs: function (row) {
      this.currentLogs = this.logsMap[row["广告主id"]] || [];
      this.logDialogVisible = true;
    },
    async execute(row) {
      const self = this;
      const logs = [];
      self.logsMap[row["广告主id"]] = logs;

      function log(step, result) {
        logs.push({ step, result });
      }

      try {
        const app = self.appList.find(a => a.appName === row["产品名"]);
        const attr = self.attributionList.find(a => a.title === row["预设归因"]);

        if (!app || !attr) {
          log("校验", "app 或归因未匹配");
          return;
        }

        const payload = {
          accountId: "20240528045",
          advertiserId: row["广告主id"],
          appId: app.appId,
          proxy: attr.proxyId,
          attributionPresetId: attr.id,
          attributionBehavior: attr.attributionBehavior,
          attributionBehaviorParams: attr.attributionBehaviorParams,
          activationReturnPercent: 100,
          maxLandingPageJumpCount: 10,
          landingPageJumpInterval: 1,
          channel: "vivo",
          media: "vivo",
          mediaChannel: row["版位"] === "主站" ? "main" : "league",
          mediumType: "direct",
          jumpMode: row["推广目标"] === "h5" ? "url" : "hap",
          materialType: self.mapMaterial(row["素材类型"]),
          shieldedCities:
              "北京市,广州市,上海市,深圳市,重庆市,杭州市,南京市,厦门市,西安市,苏州市,绍兴市,杭州市,成都市,合肥市,宁波市,天津市,佛山市,东莞市,青岛市,济南市,长沙市",
          status: 1,
          useGlobalJumpConfig: false,
          autoDailyBudget: 1,
          autoStatus: 0
        };

        // 创建计划
        await axios.post(
            "/csmfapi/api/analysis/proxy/daily/dataReport/proxyPlanCreate",
            payload,
            { headers: { "X-Satoken": self.satoken } }
        );
        log("创建计划", "成功");

        // 获取计划，最多尝试 10 次
        let plan = null;
        for (let attempt = 1; attempt <= 10; attempt++) {
          const res2 = await axios.get(
              "/csmfapi/api/analysis/proxy/daily/dataReport/proxyPlanList?current=1&pageSize=100",
              { headers: { "X-Satoken": self.satoken } }
          );
          const list = res2.data.data || [];
          plan = list.find(p => p.advertiserId === payload.advertiserId);

          if (plan) {
            log("获取计划", `成功 planId=${plan.plan} (第${attempt}次尝试)`);
            break;
          } else {
            log("获取计划", `未找到 (第${attempt}次尝试)`);
            await new Promise(r => setTimeout(r, 1000)); // 每次间隔 1 秒再请求
          }
        }

        if (!plan) {
          log("获取计划", "失败，超过最大尝试次数");
          return;
        }

        // 配置归因
        await axios.post(
            "/csmfapi/api/advertising/attribution/config",
            {
              monitorId: plan.monitorId,
              appId: plan.appId,
              media: "vivo",
              channel: "vivo",
              planId: plan.plan,
              packageName: plan.packageName,
              advertiserId: plan.advertiserId,
              attributionBehavior: plan.attributionBehavior,
              maxLandingPageJumpCount: 10,
              type: "custom",
              convertType:
                  row["转化事件类型"] === "添加到桌面"
                      ? "ADD_SCREEN"
                      : row["转化事件类型"] === "激活"
                          ? "ACTIVATION"
                          : "UNKNOWN",
              srcType: "Quickapp",
              srcId: row["数据源ID"]
            },
            { headers: { "X-Satoken": self.satoken } }
        );
        log("归因配置", "成功");

        // 开启监控
        await axios.get(
            "/csmfapi/api/advertising/activity/monitor/" + plan.monitorId,
            { headers: { "X-Satoken": self.satoken } }
        );
        log("开启监控", "成功");

        // 自定义函数
        await self.checkMonitor(plan.monitorId, log);

      } catch (err) {
        log("错误", err.message || JSON.stringify(err));
      }
    },

    // 串行执行所有行
    async executeAll() {
      const self = this;
      try {
        for (const row of self.tableData) {
          await self.execute(row); // 串行逐个执行
        }
        self.$message.success("所有数据执行完成");
      } catch (err) {
        self.$message.error("执行过程中有错误: " + (err.message || err));
      }
    },
    checkMonitor: function (monitorId, log, done) {
      var self = this;
      var tries = 0;
      function poll() {
        tries++;
        axios
          .get(
            "/csmfapi/api/advertising/activity/monitor/debug?monitorId=" +
            monitorId,
            { headers: { "X-Satoken": self.satoken } }
          )
          .then(function (res) {
            var data = res.data;
            if (data && data.data && data.data.logs && data.data.logs.length >= 4) {
              var msg = data.data.logs[3].message[0];
              if (msg === "调试结果: 成功") {
                log("监控检测", "成功");
                done && done();
                return;
              }
            }
            if (tries < 5) {
              setTimeout(poll, 2000);
            } else {
              log("监控检测", "失败(5次未成功)");
              done && done();
            }
          })
          .catch(function (err) {
            log("监控检测", "错误 " + err);
            done && done();
          });
      }
      poll();
    },
    mapMaterial: function (val) {
      var map = {
        清理页: "isClearPage",
        字体放大: "isFontSize",
        天气页: "isWeatherPage",
        省电页: "isElectric",
        养生: "isYangshen",
        wifi页: "isWifi",
        计步: "isStepNumber",
        红包: "isRedPacketPage",
        壁纸: "isBizhi",
        领红包: "isReward",
        短剧: "isVideo"
      };
      return map[val] || "isDefault";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/kehu/csmfqd.vue